import { render, staticRenderFns } from "./ModalAddPhoto.vue?vue&type=template&id=1c9c765a&scoped=true&"
import script from "./ModalAddPhoto.vue?vue&type=script&lang=js&"
export * from "./ModalAddPhoto.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddPhoto.vue?vue&type=style&index=0&id=1c9c765a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9c765a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c9c765a')) {
      api.createRecord('1c9c765a', component.options)
    } else {
      api.reload('1c9c765a', component.options)
    }
    module.hot.accept("./ModalAddPhoto.vue?vue&type=template&id=1c9c765a&scoped=true&", function () {
      api.rerender('1c9c765a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Modal/ModalAddPhoto.vue"
export default component.exports